import React from "react";
import { css } from "@emotion/css";
import { useNavigate } from "react-router-dom";
import {
    event1,
    event2,
    event3,
    event4,
    event5,
    event6,
} from "../assets/images";

const EventGallery = () => {
    const eventGalleryStyles = {
        section: css`
            padding: 2rem 0;
            background-color: #f9fafb;

            @media (min-width: 640px) {
                padding: 3rem 0;
            }

            @media (min-width: 1024px) {
                padding: 4rem 0;
            }
        `,
        container: css`
            max-width: 80rem;
            margin: 0 auto;
            padding: 0 1rem;
            @media (min-width: 640px) {
                padding: 0 1.5rem;
            }
            @media (min-width: 1024px) {
                padding: 0 2rem;
            }
        `,
        headerSection: css`
            text-align: center;
            margin-bottom: 2rem;

            @media (min-width: 640px) {
                margin-bottom: 2.5rem;
            }

            @media (min-width: 1024px) {
                margin-bottom: 3rem;
            }
        `,
        description: css`
            color: #4b5563;
            margin-bottom: 1.5rem;
            font-size: 0.875rem;
            line-height: 1.5;

            @media (min-width: 640px) {
                margin-bottom: 1.75rem;
                font-size: 0.9375rem;
            }

            @media (min-width: 1024px) {
                margin-bottom: 2rem;
                font-size: 1rem;
            }
        `,
        button: css`
            background-color: #ff6b6b;
            color: white;
            padding: 0.5rem 1.5rem;
            border-radius: 0.5rem;
            font-weight: 600;
            font-size: 0.875rem;
            transition: background-color 0.2s;

            @media (min-width: 640px) {
                padding: 0.625rem 1.75rem;
                font-size: 0.9375rem;
            }

            @media (min-width: 1024px) {
                padding: 0.75rem 2rem;
                font-size: 1rem;
            }

            &:hover {
                background-color: #ff5252;
            }
        `,
        collageContainer: css`
            position: relative;
            width: 100%;
            margin-bottom: 1.5rem;
            border-radius: 0.75rem;
            overflow: hidden;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

            @media (min-width: 640px) {
                height: 400px;
                margin-bottom: 1.75rem;
                border-radius: 0.875rem;
            }

            @media (min-width: 1024px) {
                height: 600px;
                margin-bottom: 2rem;
                border-radius: 1rem;
            }
        `,
        grid: css`
            position: relative;
            inset: 0;
            display: grid;
            height: 100%;

            gap: 0.25rem;
            padding: 0.25rem;
            grid-template:
                "a a"
                "b c"
                "d e"
                "f f";
            @media (min-width: 640px) {
                gap: 0.375rem;
                padding: 0.375rem;
            }

            @media (min-width: 1024px) {
                grid-template:
                    "a b c f"
                    "a d e f";
                gap: 0.5rem;
                padding: 0.5rem;
            }
        `,
        imageItem: css`
            position: relative;
            overflow: hidden;
            border-radius: 0.25rem;
            cursor: pointer;
            border-radius: 10px;
            @media (min-width: 640px) {
                border-radius: 0.375rem;
            }

            @media (min-width: 1024px) {
                border-radius: 0.5rem;
            }

            &:hover img {
                transform: scale(1.1);
            }
        `,
        imageItemA: css`
            ...eventGalleryStyles.imageItem;
            grid-area: a;
        `,
        imageItemB: css`
            ...eventGalleryStyles.imageItem;
            grid-area: b;
        `,
        imageItemC: css`
            ...eventGalleryStyles.imageItem;
            grid-area: c;
        `,
        imageItemD: css`
            ...eventGalleryStyles.imageItem;
            grid-area: d;
        `,
        imageItemE: css`
            ...eventGalleryStyles.imageItem;
            grid-area: e;
        `,
        imageItemF: css`
            ...eventGalleryStyles.imageItem;
            grid-area: f;
        `,
        image: css`
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s;
            border-radius: 10px;
        `,
        imageFill: css`
            width: 100%;
            height: 100%;
            object-fit: fill;
            transition: transform 0.5s;
        `,
        imageOverlay: css`
            position: absolute;
            inset: 0;
            background-color: rgba(0, 0, 0, 0.2);
            opacity: 0;
            transition: opacity 0.3s;
        `,
        overlayText: css`
            position: absolute;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            pointer-events: none;

            @media (max-width: 639px) {
                display: none;
            }
        `,
        overlayContent: css`
            background-color: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(4px);
            border-radius: 0.75rem;
            padding: 1rem;
            text-align: center;
            max-width: 100%;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);

            @media (min-width: 640px) {
                border-radius: 0.875rem;
                padding: 1.5rem;
                max-width: 24rem;
            }

            @media (min-width: 1024px) {
                border-radius: 1rem;
                padding: 2rem;
                max-width: 28rem;
            }
        `,
        overlayTitle: css`
            font-size: 2rem;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 0.5rem;

            @media (min-width: 640px) {
                font-size: 1.5rem;
                margin-bottom: 0.625rem;
            }

            @media (min-width: 1024px) {
                font-size: 1.875rem;
                margin-bottom: 0.75rem;
            }
        `,
        overlayTitleMobile: css`
            ...eventGalleryStyles.overlayTitle;
            font-size: 2rem;
            @media (min-width: 640px) {
                display: none;

            }
        `,
        overlaySubtitle: css`
            color: #374151;
            font-size: 0.875rem;

            @media (min-width: 640px) {
                font-size: 1rem;
            }

            @media (min-width: 1024px) {
                font-size: 1.125rem;
            }
        `,
        titleSection: css`
            text-align: center;
        `,
        title: css`
            font-size: 1.5rem;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 0.75rem;

            @media (min-width: 640px) {
                font-size: 1.75rem;
                margin-bottom: 0.875rem;
            }

            @media (min-width: 1024px) {
                font-size: 1.875rem;
                margin-bottom: 1rem;
            }
        `,
    };

    const navigate = useNavigate();

    const handleShowcaseYourTalentClick = () => {
        navigate("/reg", { state: { type: "talent" } });
    };

    return (
        <section
            className={eventGalleryStyles.section}
            id="event-gallery"
            aria-labelledby="event-gallery-title"
        >
            <div className={eventGalleryStyles.container}>
                <div className={eventGalleryStyles.headerSection}>
                    <p className={eventGalleryStyles.description}>
                        Discover the transformative power of Club Mango's
                        community events. From workshops to wellness retreats,
                        each gathering is designed to foster personal growth and
                        meaningful connections.
                    </p>
                    <button
                        className={eventGalleryStyles.button}
                        onClick={handleShowcaseYourTalentClick}
                    >
                        Showcase Your Talent
                    </button>
                </div>

                <h3 className={eventGalleryStyles.overlayTitleMobile}>
                    Our Events
                </h3>

                <div className={eventGalleryStyles.collageContainer}>
                    {/* Main collage container */}
                    <div className={eventGalleryStyles.grid}>
                        <div className={eventGalleryStyles.imageItemA}>
                            <img
                                src={event1}
                                alt="Event 1"
                                className={eventGalleryStyles.image}
                            />
                            <div
                                className={eventGalleryStyles.imageOverlay}
                            ></div>
                        </div>

                        <div className={eventGalleryStyles.imageItemB}>
                            <img
                                src={event2}
                                alt="Event 2"
                                className={eventGalleryStyles.image}
                            />
                            <div
                                className={eventGalleryStyles.imageOverlay}
                            ></div>
                        </div>

                        <div className={eventGalleryStyles.imageItemC}>
                            <img
                                src={event3}
                                alt="Event 3"
                                className={eventGalleryStyles.image}
                            />
                            <div
                                className={eventGalleryStyles.imageOverlay}
                            ></div>
                        </div>

                        <div className={eventGalleryStyles.imageItemD}>
                            <img
                                src={event6}
                                alt="Event 6"
                                className={eventGalleryStyles.image}
                            />
                            <div
                                className={eventGalleryStyles.imageOverlay}
                            ></div>
                        </div>

                        <div className={eventGalleryStyles.imageItemE}>
                            <img
                                src={event5}
                                alt="Event 5"
                                className={eventGalleryStyles.image}
                            />
                            <div
                                className={eventGalleryStyles.imageOverlay}
                            ></div>
                        </div>

                        <div className={eventGalleryStyles.imageItemF}>
                            <img
                                src={event4}
                                alt="Event 4"
                                className={eventGalleryStyles.image}
                            />
                            <div
                                className={eventGalleryStyles.imageOverlay}
                            ></div>
                        </div>
                    </div>

                    {/* Centered overlay text with background */}
                    <div className={eventGalleryStyles.overlayText}>
                        <div className={eventGalleryStyles.overlayContent}>
                            <h3 className={eventGalleryStyles.overlayTitle}>
                                Our Events
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EventGallery;
